import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { TypeOrmModule } from '@nestjs/typeorm';
import { SaleBudgetEntity } from "./sale-budget.entity";
import { SaleBudgetController } from "./sale-budget.controller";
import { SaleBudgetService } from "./sale-budget.service";
import { HrmsEmpDetService } from "@gtpl/shared-services/masters";


@Module({
    imports: [
      TypeOrmModule.forFeature([SaleBudgetEntity])
    ],
    controllers: [SaleBudgetController],
    providers: [ApplicationExceptionHandler,SaleBudgetController,SaleBudgetService,HrmsEmpDetService],
  })
  export class SaleBudgetModule { }